import { create } from 'zustand'

// Define the structure of your modal state
interface ModalState {
    [modalId: string]: {
        isOpen: boolean
    }
}

interface ModalStateStore {
    modals: ModalState
    openModal: (modalId: string) => void
    closeModal: (modalId: string) => void
    toggleModal: (modalId: string) => void
    isModalOpen: (modalId: string) => boolean
}

export const useModalStateStore = create<ModalStateStore>((set, get) => ({
    modals: {}, // Starts with no modals open

    openModal: (modalId) =>
        set((state) => ({
            modals: { ...state.modals, [modalId]: { isOpen: true } }
        })),

    closeModal: (modalId) =>
        set((state) => ({
            modals: { ...state.modals, [modalId]: { isOpen: false } }
        })),

    toggleModal: (modalId) =>
        set((state) => ({
            modals: {
                ...state.modals,
                [modalId]: { isOpen: !state.modals[modalId]?.isOpen }
            }
        })),

    isModalOpen: (modalId) => !!get().modals[modalId]?.isOpen
}))
